import React, { useEffect, useState } from 'react'
import cookie from "js-cookie"
import { useNavigate } from 'react-router-dom';
import "./admin.css"
import axios from 'axios';
function AdminDashboard() {
       const getCookieUser = cookie.get("user");
        const userInfo = getCookieUser ? JSON.parse(getCookieUser) : null;
        console.log(userInfo, "userInfo")
        const navigate = useNavigate()
        const logoutHandler = () => {
            cookie.remove("user")
            navigate("/login")
        }
        const [count, setCount] = useState(0)

    const getItemsCount = async () => {
        try {
            const result = await axios.get(
              `${process.env.REACT_APP_API_URL}/countForDash`,
              {
                //`${process.env.REACT_APP_API_URL}/loginnow`
                headers: {
                  Authorization: `Bearer ${userInfo?.token}`,
                },
              }
            );
            console.log(result,"result")
            setCount(result.data.body)
        } catch (error) {
            console.log(error)
        }
    }
    useEffect(() => {
        getItemsCount()
    }, [])
    return (
        <div className="d-flex" id="admin-dashboard">
            {/* Sidebar */}
            <div className="bg-dark text-white p-3 sidebar" style={{ width: '250px', minHeight: '100vh' }}>
                <h4 className="text-center text-white mb-4">Admin Panel</h4>
                <ul className="nav flex-column">
                    <li className="nav-item mb-2">
                        <a className="nav-link text-white" href="/AdminDashboard"><i className="fas fa-tachometer-alt me-2"></i>Dashboard</a>
                    </li>
                    <li className="nav-item mb-2">
                    <a className="nav-link text-white" href="/UserTable"><i className="fas fa-users me-2"></i>Users</a>
                    </li>
                    <li className="nav-item mb-2">
              <a className="nav-link text-white" href="/ContactUsTable"><i className="fas fa-tools me-2"></i>Contact Us </a>
            </li>
            <li className="nav-item mb-2">
              <a className="nav-link text-white" href="/BookingTable"><i className="fas fa-tools me-2"></i>Washing Services</a>
            </li>
                    {/* <li className="nav-item mb-2">
                        <a className="nav-link text-white" href="#"><i className="fas fa-shopping-cart me-2"></i>Orders</a>
                    </li> */}
                    <li className="nav-item" onClick={logoutHandler}>
                        <a className="nav-link text-white" href="/logout"><i className="fas fa-sign-out-alt me-2"></i>Logout</a>
                    </li>
                </ul>
            </div>

            {/* Main Content */}
            <div className="flex-grow-1">
                {/* Navbar */}
                <nav className="navbar navbar-expand navbar-light bg-light px-4 shadow-sm">
                    <span className="navbar-brand">Welcome, Admin</span>
                </nav>

                {/* Content Area */}
                <div className="p-4">
                    <h2>Dashboard Overview</h2>
                    <div className="row mt-4">
                        <div className="col-md-4 mb-3">
                            <div className="card text-white bg-primary p-3">
                                <h5>Total Users</h5>
                                <h3>{count?.userCount}</h3>
                            </div>
                        </div>
                        <div className="col-md-4 mb-3">
                            <div className="card text-white bg-success p-3">
                                <h5>Total Contact Us</h5>
                                <h3>{count?.contactUs}</h3>
                            </div>
                        </div>
                        <div className="col-md-4 mb-3">
                            <div className="card text-white bg-warning p-3">
                                <h5>Total Washing Services</h5>
                                <h3>{count?.appointments}</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AdminDashboard